import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrandProvider } from './brands/contexts/BrandContext';
import { I18nProvider } from './features/contexts/I18nContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrandProvider>
        <I18nProvider>
          <App />
        </I18nProvider>
      </BrandProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();